import './UnderlinePanels-e4b325b9.css';

var classes = {"StyledUnderlineWrapper":"prc-UnderlinePanels-StyledUnderlineWrapper-DusUj"};

export { classes as default };
